<template>
  <div class="wrapper" id="pdf-container" v-loading="loading"></div>
</template>
<script>
import getPdfDoc from '@/lib/pdf'

export default {
  props: {
    src: String,
    withCredentials: {
      type: Boolean,
      default: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    src(newValue, oldValue) {
      if (newValue !== oldValue) this.getDocument()
    },
  },
  mounted() {
    this.getDocument()
  },
  methods: {
    getDocument() {
      const _this = this
      _this.$emit('start')

      getPdfDoc(_this.src, {
        httpHeaders: {
          'x-requested-with': 'XMLHttpRequest',
          Accept: '*/*',
        },
        withCredentials: _this.withCredentials,
      })
        .then(pdf => {
          const pageNumber = 1
          pdf.getPage(pageNumber).then(function(page) {
            let id = ''
            const idTemplate = 'cw-pdf-'
            const pageNum = pdf.numPages
            _this.createSeriesCanvas(pageNum, idTemplate)
            for (let i = 1; i <= pageNum; i++) {
              id = idTemplate + i
              _this.renderPDF(pdf, i, id)
            }
          })
          _this.$emit('end')
        })
        .catch(() => {
          _this.$emit('end')
        })
    },
    renderPDF(pdf, i, id) {
      pdf.getPage(i).then(function(page) {
        const scale = 1.5
        const viewport = page.getViewport(scale)
        //
        //  准备用于渲染的 canvas 元素
        //
        const canvas = document.getElementById(id)
        const context = canvas.getContext('2d')
        canvas.height = viewport.height
        canvas.width = viewport.width
        //
        // 将 PDF 页面渲染到 canvas 上下文中
        //
        const renderContext = {
          canvasContext: context,
          viewport,
        }
        page.render(renderContext)
      })
    },
    createSeriesCanvas(num, template) {
      let id = ''
      for (let j = 1; j <= num; j++) {
        id = template + j
        this.createPdfContainer(id, 'pdfClass')
      }
    },
    createPdfContainer(id, className) {
      const pdfContainer = document.getElementById('pdf-container')
      const canvasNew = document.createElement('canvas')
      canvasNew.id = id
      canvasNew.className = className
      pdfContainer.appendChild(canvasNew)
    },
  },
}
</script>

<style scoped>
.wrapper {
  width: 100%;
  height: 100%;
}
</style>
